// Generated by scripts/generate-root-overlay-messages.mjs — do not edit.
// Regenerate with: node scripts/generate-root-overlay-messages.mjs
import type { AbstractIntlMessages } from 'next-intl'

const messages: AbstractIntlMessages = {
  AdminImpersonate: {
    title: 'Impersonate User',
    description: 'Sign in as another user to debug issues and see what they see.',
    backToApp: 'Back to app',
    searchPlaceholder: 'Search by email or name...',
    allWorkspaces: 'All workspaces',
    usersFound: 'users',
    impersonate: 'Impersonate',
    noUsers: 'No users found',
    noWorkspaces: 'No workspaces',
    loadMore: 'Load more',
    never: 'Never',
    justNow: 'Just now',
    confirmTitle: 'Confirm Impersonation',
    confirmDescription:
      'You are about to sign in as {email}. Your admin session will be preserved and can be restored at any time.',
    cancel: 'Cancel',
    bannerText: 'Impersonating {email}',
    stopImpersonating: 'Stop Impersonating',
    impersonationStarted: 'Now impersonating {email}',
    sessionRestored: 'Admin session restored',
    failedToImpersonate: 'Failed to impersonate user',
  },
  ChunkLoadRecovery: {
    title: "Trellis couldn't load this version",
    description:
      'Some app files are out of sync after an update. Update and reload Trellis to fetch the current version. Your saved data is safe.',
    action: 'Update and reload',
    hint: 'If this keeps happening, close your other Trellis tabs and try again.',
  },
  Common: {
    editableLabelHint:
      'Double-click to edit. Use Enter or F2 with a keyboard, or tap on a touchscreen.',
    editableLabelRequired: 'Enter a name.',
    skipToContent: 'Skip to content',
    dismiss: 'Dismiss',
    uncategorized: 'Uncategorized',
    pushToGuesty: 'Push to Guesty',
    pushNoteToGuestyTitle: 'Push note to Guesty',
    pushNoteToGuestyDescription:
      "Add a note to this reservation's General Notes in Guesty. We'll confirm it saved in Guesty before showing success.",
    pushNoteToGuestyPlaceholder: 'e.g. Guest requested a baby cot (complimentary)',
    pushNoteToGuestySuccess: 'Pushed to Guesty',
    pushNoteToGuestyError:
      "Couldn't update Guesty — nothing was changed. Try again in a minute, or contact support if it keeps happening.",
    pushNoteToGuestyEmpty: 'Add a note before pushing.',
    pushing: 'Pushing…',
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    copyToClipboard: 'Copy',
    unknown: 'Unknown',
    noMessagesYet: 'No messages yet',
    repliedTo: 'Replied to',
    firstName: 'First Name',
    lastName: 'Last Name',
    confirm: 'Confirm',
    release: 'Release',
    disconnect: 'Disconnect',
    creating: 'Creating...',
    deleting: 'Deleting...',
    adding: 'Adding...',
    loading: 'Loading...',
    today: 'Today',
    activity: 'Activity',
    yesterday: 'Yesterday',
    sending: 'Sending...',
    description: 'Description',
    added: 'Added',
    search: 'Search...',
    addFilter: 'Add filter',
    cancelledByUser: 'Cancelled by user',
    searchProperties: 'Search properties...',
    searchTags: 'Search tags...',
    searchGroups: 'Search groups...',
    searchMembers: 'Search members...',
    searchContacts: 'Search contacts...',
    addComment: 'Add a comment...',
    goToPreviousMonth: 'Go to the Previous Month',
    goToNextMonth: 'Go to the Next Month',
    searchProperties2: 'Search properties...',
    noOptionsFound: 'No options found',
    clearAllFilters: 'Clear all filters',
    noPropertiesFound: 'No properties found',
    tags: 'Tags',
    conversationTags: 'Conversation Tags',
    conversationTagsDescription: 'Classifies the conversation, not the reservation.',
    conversationTagAiHint:
      'Sparkle tags were added by AI and stay until someone removes them, even if the booking status changes.',
    noResults: 'No results.',
    itemCount: '{count, plural, one {# item} other {# items}}',
    itemCountLowerBound: '{count, plural, one {#+ item} other {#+ items}}',
    rowsSelected: '{selected} of {total} row(s) selected.',
    rowsPerPage: 'Rows per page',
    pageOf: 'Page {page} of {total}',
    goToFirstPage: 'Go to first page',
    goToPreviousPage: 'Go to previous page',
    goToNextPage: 'Go to next page',
    goToLastPage: 'Go to last page',
    showingRange: 'Showing {start}–{end} of {total}',
    pageOfPages: 'Page {page} of {total}',
    firstPage: 'First page',
    previousPage: 'Previous page',
    nextPage: 'Next page',
    lastPage: 'Last page',
    close: 'Close',
    reset: 'Reset',
    activeFilters: 'Active filters:',
    removeFilter: 'Remove filter',
    clickToUpload: 'Click to upload',
    orDragAndDrop: 'or drag and drop',
    maxSize: 'Max size: {size}',
    removeFile: 'Remove {name}',
    pickADate: 'Pick a date',
    pickADateRange: 'Pick a date range',
    addTag: 'Add tag...',
    removeTag: 'Remove {tag}',
    createNewTag: 'Create new tag',
    manageTags: 'Manage tags',
    pressToAddFields: 'Press {key} to add fields',
    viewDetails: 'View details',
    noData: 'No data',
    noContactsFound: 'No contacts found',
    noRolesAvailable: 'No roles available',
    noMembersAvailable: 'No members available',
    noGroupsAvailable: 'No groups available',
    noInboxesAvailable: 'No inboxes available',
    noAgentsAvailable: 'No agents available',
    noPropertiesAvailable: 'No properties available',
    noTagsFound: 'No tags found',
    noPropertiesToDisplay: 'No properties to display',
    loadingMap: 'Loading map...',
    noOperatorsScheduled: 'No operators scheduled',
    noPropertiesWithActivity: 'No properties with activity',
    noPulseYet: 'No pulse yet',
    noShiftsAvailable: 'No shifts available',
    noRunsYet: 'No runs yet',
    noRunSelected: 'No run selected',
    noPropertiesMatch: 'No properties match',
    noItemsAddedYet: 'No items added yet.',
    noPhotosAddedYet: 'No photos added yet.',
    noDocumentsAddedYet: 'No documents added yet.',
    noTasksForReservation: 'No tasks for this reservation',
    addTasks: 'Add Tasks',
    deleteMessage: 'Delete Message',
    total: 'Total',
    remaining: 'Remaining',
    done: 'Done',
    inProgress: 'In Progress',
    upcomingToday: 'Upcoming Today',
    completed: 'Completed',
    note: 'Note',
    poweredByTrellis: 'Powered by Trellis',
    estimated: 'Est.',
    minutes: 'minutes',
    min: 'min',
    back: 'Back',
    backToFlow: 'Back to flow',
    next: 'Next',
    resubmit: 'Resubmit',
    checkNow: 'Check Now',
    created: 'Created:',
    noConnectionsConfigured: 'No PMS connections configured',
    selectDepartment: 'Select department',
    selectPriority: 'Select priority',
    selectTags: 'Select tags...',
    tagsSelected: '{count} {count, plural, one {tag} other {tags}} selected',
    selectAll: 'Select all',
    deselectAll: 'Deselect all',
    closePanel: 'Close',
    clearSearch: 'Clear search',
    unassign: 'Unassign',
    notes: 'Notes',
    syncReservation: 'Sync reservation from PMS',
    refreshChat: 'Refresh chat',
    openInNewTab: 'Open in new tab',
    browserLiveView: 'Browser Live View',
    viewCreated: 'View created',
    viewUpdated: 'View updated',
    viewDeleted: 'View deleted',
    failed: 'Failed',
    typeAMessage: 'Type a message...',
    selectANumber: 'Select a number',
    pasteALink: 'Paste a link',
    searchTools: 'Search tools...',
    searchByNameOrEmail: 'Search by name or email...',
    whatDidYouFind: 'What did you find?',
    descriptionOptional: 'Description (optional)',
    addADescription: 'Add a description...',
    filterByRole: 'Filter by role',
    enterFullName: 'Enter full name',
    enterEmailAddress: 'Enter email address',
    describeTestPrompt: 'Describe what you want to test...',
    selectSection: 'Select section',
    selectFieldType: 'Select field type',
    addAnOption: 'Add an option',
    optional: 'Optional',
    selectField: 'Select field...',
    enterAuthToken: 'Enter your Auth Token',
    documents: 'Documents',
    photos: 'Photos',
    add: 'Add',
    reservationDetails: 'Reservation Details',
    detail: 'Detail',
    chat: 'Chat',
    tasks: 'Tasks',
    tasksDone: '{completed}/{total} done',
    addTask: 'Add Task',
    noConversationLinked: 'No conversation linked to this reservation',
    syncing: 'Syncing...',
    fetchChat: 'Fetch chat',
    openInInbox: 'Open in inbox',
    openInAiAssistant: 'Open in AI assistant',
    sessionUnavailable: 'This conversation is no longer available.',
    retry: 'Retry',
    saving: 'Saving…',
    start: 'Start',
    end: 'End',
    duration: 'Duration',
    scheduled: 'Scheduled',
    mapFailedToLoad: 'Map failed to load',
    errorLoadingTask: 'Error loading task',
    status: 'Status',
    unnamed: 'Unnamed',
    guest: 'Guest',
    unknownError: 'Unknown error',
    contacts: 'Contacts',
    addContact: 'Add contact',
    members: 'Members',
    addMember: 'Add member',
    roles: 'Roles',
    addRole: 'Add role',
    properties: 'Properties',
    addProperty: 'Add property',
    propertyGroups: 'Property groups',
    addGroup: 'Add group',
    inboxes: 'Inboxes',
    addInbox: 'Add inbox',
    agents: 'Agents',
    addAgent: 'Add agent',
    linking: 'Linking...',
    addTasksCount: 'Add {count} {count, plural, one {Task} other {Tasks}}',
    unknownProperty: 'Unknown Property',
    unassigned: 'Unassigned',
    untitledVisit: 'Untitled visit',
    untitled: 'Untitled',
    yes: 'Yes',
    no: 'No',
    city: 'City',
    conversation: 'Conversation',
    Roles: {
      admin: 'Admin',
      manager: 'Manager',
      member: 'Member',
      viewer: 'Viewer',
      frontOffice: 'Front Office',
      maintenance: 'Maintenance',
      cleaner: 'Cleaner',
      inspection: 'Inspection',
    },
    preview: 'PREVIEW',
    clearFilters: 'Clear filters',
    authorizationComplete: 'Authorization Complete',
    closeWindowAndReturn: 'You can close this window and return to Trellis.',
    autoCloseWindow: 'This window will close automatically...',
    failedToSave: 'Failed to save',
    mapContainerNotFound: 'Map container not found',
    nameRequired: 'Name is required',
    checklistMustHaveOption:
      'A checklist step has no options to choose from. Add at least one option or remove that checklist step before saving.',
    fixErrorsBeforeSave: 'Fix the errors in the form before saving',
    statusTodo: 'To Do',
    statusInProgress: 'In Progress',
    statusDone: 'Done',
    statusCancelled: 'Cancelled',
    statusBlocked: 'Blocked',
    ownerStay: 'Owner stay',
    statusOnHold: 'On Hold',
    removed: 'removed',
    lightMode: 'Light mode',
    darkMode: 'Dark mode',
    toggleSidebar: 'Toggle sidebar',
    ai: 'AI',
    customize: 'Customize',
    via: 'via',
    triggeredBy: 'Triggered by',
    viewTriggeringMessage: 'View triggering message',
    openSidebarSession: 'Open sidebar session',
    viewConversation: 'View conversation',
    viewSession: 'View session',
    saveView: 'Save View',
    clickToEdit: 'Click to edit',
    url: 'URL',
    filename: 'Filename',
    addFiles: 'Add files',
    uploading: 'Uploading...',
    groupNamePlaceholder: 'Group name',
    fields: 'Fields',
    download: 'Download',
    rangeDay: 'Day',
    rangeWeek: 'Week',
    range15Days: '15 Days',
    rangeMonth: 'Month',
    rangeCustom: 'Custom',
    rangeStartDate: 'Start date',
    rangeEndDate: 'End date',
    rangePickStart: 'Pick the start date',
    rangePickEnd: 'Pick the end date',
    rangeMaxDays: 'Select a range of up to {days} days.',
    custom: 'Custom...',
    tomorrow: 'Tomorrow',
    justNow: 'just now',
    now: 'now',
    selectMonth: 'Select month',
    selectYear: 'Select year',
    viewTrace: 'View trace',
    system: 'System',
    actorAiAgent: 'AI Agent',
    actorIntegration: 'Integration',
    actorUser: 'User',
    pulse: 'Pulse',
    active: 'Active',
    agent: 'Agent',
    channels: 'Channels',
    contact: 'Contact',
    content: 'Content',
    inactive: 'Inactive',
    memory: 'Memory',
    memoryScopeWorkspace: 'Workspace-wide memory',
    message: 'Message',
    more: 'more',
    noDetailsAvailable: 'No details available',
    noMembersYet: 'No members yet',
    noOpenTasks: 'No open tasks',
    openAgent: 'Open agent',
    openFullConversation: 'Open full conversation',
    openFullDocument: 'Open full document',
    openTasks: 'Open tasks',
    property: 'Property',
    reservations: 'Reservations',
    sharedWith: 'Shared with',
    site: 'Site',
    siteLinked: 'Linked',
    source: 'Source',
    lastEdited: 'Last edited',
    statusLive: 'Live',
    statusTranscribing: 'Transcribing',
    statusUpcoming: 'Upcoming',
    statusFailed: 'Failed',
    statusPassed: 'Passed',
    statusPending: 'Pending',
    statusWaiting: 'Waiting',
    statusSkipped: 'Skipped',
    saved: 'Saved',
    saveFailed: 'Failed to save',
    discardChangesPrompt: 'Discard unsaved changes?',
    documentChangedElsewhere:
      'This document was updated elsewhere. Save will overwrite those changes.',
    discard: 'Discard',
    keepEditing: 'Keep editing',
    collapse: 'Collapse',
    expand: 'Expand',
    tagName: 'Tag name',
    tagAddError:
      "Couldn't add the label. This is an issue on our end — please try again in a moment.",
    tagRemoveError:
      "Couldn't remove the label. This is an issue on our end — please try again in a moment.",
    tagAccessDeniedError:
      "You don't have access to this conversation. Ask an admin to grant you access to its inbox view.",
    tagViewCapError:
      "Couldn't update the label — this workspace has too many restricted inbox views to check. Ask an admin to reduce them or grant you access.",
    tagStaleError:
      'This label no longer exists — it may have been deleted. Refresh and pick another.',
    urgent: 'Urgent',
    moreActions: 'More actions',
    drag: 'Drag to reorder',
    you: 'You',
    activityAssigned: 'assigned to {name}',
    activityAttachmentAdded: 'added an attachment',
    activityAttachmentRemoved: 'removed an attachment',
    activityBlockerAdded: 'added a blocker',
    activityBlockerRemoved: 'removed a blocker',
    activityCommentAdded: 'added a comment',
    activityBreezewayAssignmentDeclined: 'declined by {assignee}',
    activityBreezewayAssignmentAccepted: 'accepted by {assignee}',
    activityCreated: 'created',
    activityDeleted: 'deleted',
    activityDueDateChanged: 'changed due date to {date}',
    activityLog: 'Activity log',
    activityPriorityChanged: 'changed priority to {priority}',
    activityStatusChanged: 'changed status to {status}',
    activityUnassigned: 'unassigned {name}',
    activityUpdated: 'updated',
    activityUpdatedFields: 'updated {fields}',
    performedAction: 'performed an action',
    priorityHigh: 'High',
    other: 'Other',
    noAvailableTasksForProperty: 'No available tasks for this property',
    selectTasksToLink: 'Select tasks to link to this reservation',
    tagCount: '{count, plural, one {# tag} other {# tags}}',
    removePerson: 'Remove person',
    groupAll: 'Group all',
    mapLoading: 'Map loading',
    previous: 'Previous',
    photo: 'Photo',
    commandPalette: 'Command Palette',
    sidebar: 'Sidebar',
    sidebarMobileDescription: 'Displays the mobile sidebar.',
    loadMore: 'Load more',
    loadEarlierMessages: 'Load earlier messages',
    loadLaterMessages: 'Load later messages',
    contactMethod: 'Contact method',
    documentPreview: {
      loading: 'Loading document…',
      failed: 'Unable to display this document.',
      unsupported: 'An integrated preview is not available for this file format.',
      page: 'Page {page} of {total}',
    },
    channelIcons: {
      trellisSidebar: 'Trellis sidebar',
      domainLogo: '{domain} logo',
    },
  },
  LanguagePopup: {
    title: 'Change Language?',
    description: 'It looks like your browser language is {language}. Do you want to switch?',
    switch: 'Switch to {language}',
    dismiss: 'No thanks',
  },
  Offline: {
    title: 'You are offline',
    description: 'Check your internet connection and try again.',
    retry: 'Retry',
  },
  PageNotFound: {
    code: '404',
    title: 'Page not found',
    description: "The page you're looking for doesn't exist or has been moved.",
    goHome: 'Back to home',
    goBack: 'Go back',
  },
  Phone: {
    addParticipant: 'Add',
    addParticipantTitle: 'Add a participant',
    addParticipantDescription:
      'Dial a third person into this call. They join the live conversation.',
    addParticipantNumberLabel: 'Number or contact',
    addParticipantConfirm: 'Call',
    addParticipantPending: 'Calling…',
    removeParticipant: 'Remove from call',
    passCallTitle: 'Pass to colleague',
    passCallDescription: 'The colleague will ring. You stay connected until they answer.',
    passCallNoColleagues: 'No colleague can receive calls.',
    passCallSubmit: 'Pass call',
    passCallStarting: 'Passing…',
    passCallStarted: '{colleague} is ringing',
    passCallRinging: 'Ringing {colleague}…',
    passCallFailed: "Couldn't pass the call",
    aiHandoffSummary: 'Handoff summary',
    title: 'Phone',
    allCalls: 'All Calls',
    missedCalls: 'Missed Calls',
    incomingCall: 'Incoming Call',
    call: 'Call',
    unknown: 'Unknown',
    incomingCallStatus: 'Incoming call...',
    connecting: 'Connecting...',
    ringing: 'Ringing...',
    connected: 'Connected',
    ringtoneSilenced: 'Ringtone silenced',
    silenceRingtone: 'Silence ringtone',
    ringtoneSilencedFor: 'Ringtone silenced for {name}',
    silenceRingtoneFor: 'Silence ringtone for {name}',
    activeCall: 'Active call',
    activeCalls: '{count, plural, one {# active call} other {# active calls}}',
    activeCallWith: '{caller} · {agents}',
    activeCallUnattended: 'No one on the call',
    incomingCalls: '{count, plural, one {# incoming call} other {# incoming calls}}',
    lineLabel: 'Line: {label}',
    activeCallAgents: '{count, plural, one {# agent} other {# agents}} on call',
    join: 'Join',
    minimize: 'Minimize',
    expand: 'Expand',
    connectionFailed: 'Phone connection failed. Check network/firewall settings.',
    phoneError: 'Phone error: {error}',
    callError: 'Call error: {error}',
    phoneConnected: 'Phone connected',
    phoneNotReady: 'Phone not ready',
    failedToMakeCall: 'Failed to make call',
    outboundCallFailed: 'Call couldn’t connect',
    outboundCallFailedDesc:
      'The call couldn’t be connected. The guest wasn’t called. Please try again.',
    outboundCallDestinationRejectedDesc:
      'The destination phone network rejected the call. Check the number, then try again or use another way to contact the guest.',
    outboundCallGeoPermissionFailedDesc:
      'Calls to this number are blocked by your workspace’s geographic or anti-fraud permissions. The guest wasn’t called. Contact your workspace administrator.',
    failedToSwitchMicrophone: 'Failed to switch microphone',
    microphoneUnavailable:
      'Trellis could not access your microphone. Check that it is connected and not being used by another app, then try again. If it still fails, select your default microphone in phone settings.',
    failedToSwitchSpeaker: 'Failed to switch speaker',
    enterPhoneOrContact: 'Please enter a phone number or select a contact',
    invalidPhoneNumber: 'Invalid phone number, make sure to add the country code',
    dialerDescription: 'Enter a phone number or search a contact name.',
    failedToInitializePhone: 'Failed to initialize phone',
    dtmfSendFailed: "Couldn't send the keypad tone. Check the connection and try again.",
    voiceNotConfigured:
      "Calling isn't set up for this workspace yet. Finish phone setup in Settings → Phone numbers, then try again.",
    calls: 'Calls',
    dialing: 'Dialing...',
    makeACall: 'Make a call',
    callFrom: 'Call From',
    callTo: 'Call To',
    callToPlaceholder: '+39 333 123 4567 or contact name',
    chooseANumber: 'Choose a number',
    plusNMore: '+{count} more',
    loadingNumbers: 'Loading numbers...',
    noPhoneNumbers: 'No phone numbers available. Please add a phone number first.',
    noContactsFound: 'No contacts found',
    cancel: 'Cancel',
    default: 'Default',
    busy: 'Busy',
    missed: 'Missed',
    outcomeAnswered: 'Answered',
    outcomeAnsweredBy: 'Answered by {name}',
    outcomeAnsweredByTeam: 'Answered by your team',
    outcomeAnsweredByAi: 'Answered by AI · {name}',
    outcomeAnsweredByAiUnnamed: 'Answered by AI',
    outcomeContactHungUp: 'Contact hung up',
    outcomeHungUpBy: '{name} hung up',
    outcomeTeamHungUp: 'Your team hung up',
    outcomeAiHungUp: 'AI ended the call',
    outcomeHungUpBeforeAnswer: 'Hung up before anyone answered',
    outcomeHungUpBeforeAnswerAfter:
      'Hung up after {seconds, plural, one {# second} other {# seconds}} without an answer',
    outcomeNotAnswered: 'Not answered',
    outcomeNotAnsweredRang:
      'Not answered · rang for {seconds, plural, one {# second} other {# seconds}}',
    outcomeDeclinedBy: 'Declined by {names}',
    outcomeVoicemail: 'Went to voicemail',
    outcomeForwarded: 'Forwarded to {number}',
    outcomeFailed: 'Call failed',
    outcomeInProgress: 'In progress',
    outcomeRinging: 'Ringing',
    filterOutcome: 'Outcome',
    filterAnsweredBy: 'Answered by',
    filterEndedBy: 'Hung up by',
    filterDeclinedBy: 'Declined by',
    filterOutcomeForwarded: 'Forwarded',
    filterPartyContact: 'Contact',
    filterPartyTeam: 'Team',
    filterPartyAi: 'AI',
    goToConversation: 'Go to conversation',
    answerFailed: 'Failed to answer the call. Please try again.',
    answer: 'Answer',
    hold: 'Hold',
    holdFailed:
      "The call couldn't be put on hold because Trellis couldn't update it. It is still connected — try again.",
    resumeFailed:
      "The call couldn't be resumed because Trellis couldn't update it. It is still on hold — try again.",
    onHold: 'On hold',
    resume: 'Resume',
    switchCallFailed: 'Could not switch calls. Your current call is still connected.',
    decline: 'Decline',
    joinFailed: 'Failed to join the call. Please try again.',
    takeOver: 'Take over',
    takingOver: 'Taking over...',
    takeOverComplete: 'You are now handling the call.',
    takeOverFailed: 'Failed to take over the call. Please try again.',
    conferenceNotAvailable: 'This call was already answered or ended.',
    conferenceBeingAnswered: 'Someone is answering — you can join once connected.',
    callEnded: 'Call ended',
    callerHungUpBeforeAnswer: 'The caller hung up before you answered.',
    dismiss: 'Dismiss',
    connectionTimeout: 'Connection timed out. The call may have ended.',
    microphonePermission: {
      blockedIndicator: 'Microphone is blocked in your browser — allow it to answer calls',
      title: 'Microphone Access Required',
      description:
        'To make and receive calls, your browser needs permission to access the microphone.',
      chromeInstructions:
        'Click the lock icon (or tune icon) in the address bar, then set Microphone to "Allow". Reload the page after changing the setting.',
      safariInstructions:
        'Go to Safari > Settings > Websites > Microphone, then set this site to "Allow". Reload the page after changing the setting.',
      firefoxInstructions:
        'Click the lock icon in the address bar, then click "Connection secure" > "More Information" > Permissions tab > Microphone > "Allow". Reload the page.',
      genericInstructions:
        'Open your browser settings and allow microphone access for this site. Reload the page after changing the setting.',
      retry: 'Retry',
      close: 'Close',
    },
    microphoneSilent: {
      message: "Your microphone isn't sending any audio.",
      action: 'Check microphone',
    },
    notificationIncomingCall: 'Incoming call',
    notificationIncomingCallForWorkspace: 'Incoming call for {workspace}',
    notificationFrom: 'Call from {name}',
    microphone: 'Microphone',
    speaker: 'Speaker',
    notificationSoftAsk: {
      title: 'Turn on call alerts',
      description: 'Get notified when a call comes in, even in another tab.',
      enable: 'Enable',
      dismiss: 'Not now',
      blockedTitle: 'Your browser didn’t turn on call alerts',
      blockedChromeInstructions:
        'Chrome held back the permission request, so alerts are still off. Click the bell icon at the right of the address bar and choose "Allow", or open Chrome settings > Privacy and security > Site settings > Notifications and allow this site.',
      blockedSafariInstructions:
        'Safari didn’t grant the permission, so alerts are still off. Open Safari > Settings > Websites > Notifications, find this site and set it to "Allow".',
      blockedFirefoxInstructions:
        'Firefox didn’t grant the permission, so alerts are still off. Click the lock icon in the address bar, remove the notifications block and allow this site.',
      blockedGenericInstructions:
        'Your browser didn’t grant the permission, so alerts are still off. Open your browser’s site settings, allow notifications for this site, then reload the page.',
      close: 'Close',
    },
    whatsappCalling: {
      title: 'WhatsApp calls',
      scope:
        'Answer and manage WhatsApp calls in Trellis, including conferences and colleague transfers. External phone numbers cannot join.',
      recipient: 'Customer phone number',
      consent:
        'The customer must allow calls first. Outside the 24-hour service window, send an approved permission template.',
      permissionGranted: 'The customer allows calls.',
      permissionNeeded: 'Permission is required. You can check again after the customer replies.',
      close: 'Close',
      checkPermission: 'Check permission',
      requestPermission: 'Request permission',
      call: 'Call on WhatsApp',
      incoming: 'Incoming WhatsApp call',
      answer: 'Answer',
      reject: 'Reject for everyone',
      dismiss: 'Dismiss here',
      dismissHint: 'Dismiss only hides this alert for you. Other teammates can still answer.',
      mute: 'Mute',
      unmute: 'Unmute',
      hangUp: 'Hang up',
      playAudio: 'Play call audio',
      enable: 'Enable WhatsApp calls',
      retry: 'Retry',
      relayMissing: 'Calling is not configured for this workspace yet.',
      sipUnsupported:
        'This number is connected to another calling service. Disconnect that service before enabling calls in Trellis.',
      coexistenceUnsupported:
        'Numbers connected through WhatsApp Business app Coexistence cannot use API calls.',
      providerUnsupported:
        'Calling currently supports numbers connected directly to Meta Cloud API.',
      adminOnly: 'You need permission to manage integrations to change this setting.',
      requirements:
        'Requires a Cloud API number with a messaging limit of at least 2,000. Calls and permission messages may incur provider charges.',
      openDialer: 'Open dialer',
      status: {
        ringing: 'Ringing…',
        claiming: 'Preparing to answer…',
        connecting: 'Connecting…',
        active: 'Call connected',
        ended: 'Call ended',
        failed: 'Call failed',
      },
      errors: {
        microphone: 'Allow microphone access and check your audio device, then try again.',
        connection: 'The call could not connect. Check your connection and try again.',
        busy: 'Finish your current call before starting another.',
        unsupported:
          'This browser does not support calling. Use a current desktop browser with microphone access.',
        permission:
          'Permission could not be checked or requested. Check the messaging window and try again.',
      },
      dtlsRequired:
        'Browser calling requires DTLS audio. Update the number’s media settings before enabling it.',
      webhookRequired:
        'Subscribe the existing Meta app webhook to calls as well as messages before enabling calls.',
      configureCallFlow: 'Configure call flow',
      backToSettings: 'Back to WhatsApp settings',
      pstnUnsupported: 'WhatsApp calls do not support external phone forwarding or phone fallback.',
      limits: 'Limits for this contact',
      permissionExpires: 'Permission expires {date}',
      requestWindowClosed:
        'The 24-hour window is closed. Use an approved template to request permission.',
      permissionRequests: 'Permission requests',
      quota: '{used} / {maximum} · {period}',
      periodDay: '24 hours',
      periodWeek: '7 days',
      quotaResets: 'Resets {date}',
      quotaUnavailable: 'Meta has not returned quota details. Check permission to refresh.',
      limitReached:
        'Permission exists, but Meta is not allowing a call now. Check the limits below.',
      noNumbers: 'No WhatsApp numbers with calling enabled.',
      channel: 'Call channel',
      phoneChannel: 'Phone',
    },
  },
  Toast: {
    repeatCount: '×{count}',
    repeatCountLabel: 'Repeated {count} times',
    dismiss: 'Dismiss',
    dismissAll: 'Dismiss all',
  },
  AiAssistant: {
    title: 'AI Assistant',
  },
  Settings: {
    displayLanguageError:
      "Couldn't change the display language. Issue on our end — please try again.",
  },
  WorkspaceSwitcher: {
    switchWorkspace: 'Switch Workspace',
  },
}

export default messages
